import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2972e03b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2972e03b&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=2972e03b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972e03b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/app/jenkins/data/workspace/TEST测试环境/xcommunity-test/syx-web-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2972e03b')) {
      api.createRecord('2972e03b', component.options)
    } else {
      api.reload('2972e03b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2972e03b&scoped=true", function () {
      api.rerender('2972e03b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SettingRightPanel/index.vue"
export default component.exports